export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  logoutBtn: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard-link",
  discover: "nav-discover-link",
  leads: "nav-leads-link",
  clients: "nav-clients-link",
  onboarding: "nav-onboarding-link",
  marketing: "nav-marketing-link",
  agents: "nav-agents-link",
  bookings: "nav-bookings-link",
  conversations: "nav-conversations-link",
  subscribers: "nav-subscribers-link",
  billing: "nav-billing-link",
  settings: "nav-settings-link",
  brand: "nav-brand-logo",
  publicLeads: "nav-public-leads-link",
};

export const DASH = {
  container: "dashboard-container",
  statTotalLeads: "stat-total-leads",
  statWebsites: "stat-websites-generated",
  statOutreach: "stat-outreach-sent",
  statMrr: "stat-mrr",
  statClosedWon: "stat-closed-won",
};

export const DISCOVER = {
  industrySelect: "discover-industry-select",
  cityInput: "discover-city-input",
  stateInput: "discover-state-input",
  searchBtn: "discover-search-btn",
  resultsTable: "discover-results-table",
  importBtn: (id) => `discover-import-btn-${id}`,
  importAllBtn: "discover-import-all-btn",
  buildWebsiteBtn: (id) => `discover-build-website-btn-${id}`,
  viewSiteLink: (id) => `discover-view-site-link-${id}`,
};

export const LEADS = {
  board: "leads-kanban-board",
  column: (status) => `leads-column-${status}`,
  card: (id) => `lead-card-${id}`,
  openBtn: (id) => `lead-open-btn-${id}`,
};

export const LEAD_DETAIL = {
  container: "lead-detail-container",
  generateBtn: "lead-generate-website-btn",
  previewLink: "lead-preview-link",
  previewIframe: "lead-preview-iframe",
  statusSelect: "lead-status-select",
  scriptBtn: "lead-call-script-btn",
  scriptBody: "lead-call-script-body",
  outreachChannelSelect: "outreach-channel-select",
  outreachSubject: "outreach-subject-input",
  outreachBody: "outreach-body-input",
  outreachSubmit: "outreach-submit-btn",
  outreachList: "outreach-list",
  convertClientBtn: "lead-convert-client-btn",
};

export const BILLING = {
  container: "billing-container",
  planCard: (key) => `plan-card-${key}`,
  planSubscribe: (key) => `plan-subscribe-btn-${key}`,
  successContainer: "billing-success-container",
  cancelContainer: "billing-cancel-container",
};

export const AGENTS = {
  listContainer: "agents-list-container",
  newBtn: "agents-new-btn",
  row: (id) => `agent-row-${id}`,
  editorContainer: "agent-editor-container",
  nameInput: "agent-name-input",
  roleSelect: "agent-role-select",
  toneInput: "agent-tone-input",
  greetingInput: "agent-greeting-input",
  businessInfoInput: "agent-business-info-input",
  servicesInput: "agent-services-input",
  faqQuestionInput: "agent-faq-question-input",
  faqAnswerInput: "agent-faq-answer-input",
  faqAddBtn: "agent-faq-add-btn",
  hoursInput: "agent-hours-input",
  bookingToggle: "agent-booking-toggle",
  saveBtn: "agent-save-btn",
  deleteBtn: "agent-delete-btn",
  playgroundInput: "agent-playground-input",
  playgroundSend: "agent-playground-send",
  playgroundThread: "agent-playground-thread",
};

export const LEAD_AGENT = {
  createBtn: "lead-agent-create-btn",
  editLink: "lead-agent-edit-link",
};

export const SETTINGS = {
  container: "settings-container",
  card: (key) => `settings-card-${key}`,
};

export const SUBSCRIBERS = {
  container: "subscribers-container",
};

export const BOOKINGS = {
  container: "bookings-container",
  row: (id) => `booking-row-${id}`,
};

export const CONVERSATIONS = {
  container: "conversations-container",
  row: (id) => `conversation-row-${id}`,
};

export const CLIENTS = {
  container: "clients-container",
  addBtn: "clients-add-btn",
  toggleView: "clients-view-toggle",
  card: (id) => `client-card-${id}`,
  row: (id) => `client-row-${id}`,
  openBtn: (id) => `client-open-btn-${id}`,
  column: (status) => `clients-column-${status}`,
  formBusinessName: "client-form-business-name",
  formContactName: "client-form-contact-name",
  formEmail: "client-form-email",
  formPhone: "client-form-phone",
  formIndustry: "client-form-industry",
  formCity: "client-form-city",
  formState: "client-form-state",
  formAddress: "client-form-address",
  formZip: "client-form-zip",
  formWebsite: "client-form-website",
  formNotes: "client-form-notes",
  formStatus: "client-form-status",
  formPlan: "client-form-plan",
  formMrr: "client-form-mrr",
  formSubmit: "client-form-submit-btn",
  detailContainer: "client-detail-container",
  statusSelect: "client-status-select",
  planSelect: "client-plan-select",
  mrrInput: "client-mrr-input",
  notesInput: "client-notes-input",
  saveBtn: "client-save-btn",
  deleteBtn: "client-delete-btn",
  activityInput: "client-activity-input",
  activityKind: "client-activity-kind",
  activityAdd: "client-activity-add-btn",
  generateDocBtn: (kind) => `client-generate-doc-${kind}-btn`,
  docLink: (id) => `client-doc-link-${id}`,
};

export const ONBOARDING = {
  container: "onboarding-container",
  clientSelect: "onboarding-client-select",
  docTypeSelect: "onboarding-doc-type-select",
  priceInput: "onboarding-price-input",
  setupInput: "onboarding-setup-input",
  planSelect: "onboarding-plan-select",
  generateBtn: "onboarding-generate-btn",
  docsTable: "onboarding-docs-table",
  viewBtn: (id) => `onboarding-view-${id}`,
  deleteBtn: (id) => `onboarding-delete-${id}`,
};

export const MARKETING = {
  container: "marketing-container",
  topicInput: "marketing-topic-input",
  toneInput: "marketing-tone-input",
  ctaInput: "marketing-cta-input",
  platformToggle: (p) => `marketing-platform-${p}`,
  generateBtn: "marketing-generate-btn",
  draftPanel: (p) => `marketing-draft-${p}`,
  copyBtn: (p) => `marketing-copy-${p}-btn`,
  historyList: "marketing-history-list",
  historyItem: (id) => `marketing-history-${id}`,
};

export const PUBLIC_LANDING = {
  container: "public-landing-container",
  ctaHero: "public-cta-hero-btn",
  ctaFooter: "public-cta-footer-btn",
  contactForm: "public-contact-form",
  contactName: "public-contact-name",
  contactEmail: "public-contact-email",
  contactPhone: "public-contact-phone",
  contactBusiness: "public-contact-business",
  contactIndustry: "public-contact-industry",
  contactMessage: "public-contact-message",
  contactSubmit: "public-contact-submit-btn",
  publicLoginLink: "public-login-link",
};
